import type { RenderTreeNodePayload} from '@mantine/core';
import {Group} from 'src/design/atoms/Group';
import {
  IconBoxModel,
  IconCategoryMinus,
  IconCategoryPlus,
} from '@tabler/icons-react';

export interface AssetFileIconProps {
  isGroup: boolean;
  expanded: boolean;
}

export function AssetFileIcon({isGroup, expanded}: AssetFileIconProps) {
  if (isGroup) {
    return expanded ? (
      <IconCategoryMinus
        color="var(--mantine-color-yellow-9)"
        size={14}
        stroke={2.5}
      />
    ) : (
      <IconCategoryPlus
        color="var(--mantine-color-yellow-9)"
        size={14}
        stroke={2.5}
      />
    );
  } else {
    return <IconBoxModel size={14} stroke={2.5} />;
  }
}

export function AssetTreeLeaf({
  node,
  expanded,
  hasChildren,
  elementProps,
}: RenderTreeNodePayload) {
  return (
    <Group gap={5} {...elementProps}>
      <AssetFileIcon isGroup={hasChildren} expanded={expanded} />
      <span>{node.label}</span>
    </Group>
  );
}
